// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"9b2d50e0","556":"c3ebac97","727":"bf1f27dc"}[chunkId] + ".chunk.css";
};